import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api, apiError } from "@/lib/api";
import { FlaskConical, X } from "lucide-react";
import { toast } from "sonner";

export function TestersPanel() {
  const qc = useQueryClient();
  const [email, setEmail] = useState("");
  const { data = [] } = useQuery({ queryKey: ["admin-testers"], queryFn: async () => (await api.get("/admin/testers")).data });
  const save = async (addr, is_tester) => {
    try {
      await api.post("/admin/testers", { email: addr, is_tester });
      qc.invalidateQueries({ queryKey: ["admin-testers"] });
      toast.success(is_tester ? "Tester added" : "Tester removed");
      setEmail("");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  return (
    <div data-testid="testers-panel" className="glass rounded-2xl p-5">
      <h3 className="font-display font-bold flex items-center gap-2"><FlaskConical className="h-4 w-4 text-amber-300" /> Payment testers</h3>
      <p className="text-xs text-slate-400 mt-1">Only these accounts can use the TEST-MODE Speed Pass / Speed Token buttons. Everyone else sees "Coming soon".</p>
      <form onSubmit={(e) => { e.preventDefault(); if (email) save(email, true); }} className="flex gap-2 mt-4">
        <input data-testid="tester-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="user@email.com"
          className="flex-1 h-10 rounded-full bg-white/5 border border-white/10 px-4 text-sm outline-none focus:border-amber-400/40" />
        <button data-testid="tester-add-btn" type="submit" className="btn-gold rounded-full px-5 text-sm font-semibold">Add tester</button>
      </form>
      <div className="mt-4 space-y-2">
        {data.length === 0 && <p className="text-sm text-slate-400">No testers yet.</p>}
        {data.map((t) => (
          <div key={t.user_id} data-testid="tester-row" className="flex items-center gap-3 text-sm">
            <span className="flex-1">{t.name} <span className="text-slate-400">· {t.email}</span></span>
            <button data-testid={`tester-remove-${t.user_id}`} onClick={() => save(t.email, false)} className="text-slate-400 hover:text-pink-300"><X className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
